import { User } from './models/user.model';
import { Lookup } from './models/lookup.model';

export var AppGlobals = {
  // URL: 'http://localhost:5002/api/',
  // URL: 'http://localhost:5002/api/:5002/api/',
  URL: 'https://node.medimatters.co.za/api/',
  HEADERS: new Headers({ 'Content-Type': 'application/json' }),
};
